import axiosInstance from "../../../../config/axios-config";

async function fetchOngoingProjectDetails(url, jwtToken, setOngoingProject) {
    try {
        const response = await axiosInstance.get(url, {
            headers: {
                "Authorization": `Bearer ${jwtToken}` 
            }
        });

        const data = response.data;

        // TODO :: Remove it
        console.log(response);
        console.log(data);

        setOngoingProject(data);
    } catch(err) {
        // TODO :: Comment it after work done
        console.log(err);
        setOngoingProject({});
    }
}

async function updateOngoingProjectDeadline(url, jwtToken, ongoingProject) {
    try {
        const response = await axiosInstance.put(url, ongoingProject, {
            headers: {
                "Authorization": `Bearer ${jwtToken}` 
            }
        });

        const data = response.data;

        // TODO :: Remove it
        console.log(response);
        console.log(data);
    } catch(err) {
        // TODO :: Comment it after work done
        console.log(err);
    }
}

async function closeOngoingProject(url, jwtToken) {
    try {
        const response = await axiosInstance.put(url, { }, {
            headers: {
                "Authorization": `Bearer ${jwtToken}` 
            }
        });

        const data = response.data;

        // TODO :: Remove it
        console.log(response);
        console.log(data);
    } catch(err) {
        // TODO :: Comment it after work done
        console.log(err);
    }
}

async function deleteOngoingProject(url, jwtToken) {
    try {
        const response = await axiosInstance.delete(url, {
            headers: {
                "Authorization": `Bearer ${jwtToken}` 
            }
        });

        const data = response.data;

        // TODO :: Remove it
        console.log(response);
        console.log(data);
    } catch(err) {
        // TODO :: Comment it after work done
        console.log(err);
    }
}

export { closeOngoingProject, deleteOngoingProject, fetchOngoingProjectDetails, updateOngoingProjectDeadline };